//import * as Im from 'immutable';
import * as model from "../models";
import { MessageActions } from "../actions/message.actions"

export class Message {
	id: number
	type: string
	message: string
}
export interface MessageState {
	messages: Message[]
};

const initialState: MessageState  = {
	messages: []
}

export const messageReducer = (state = initialState, action) => {
	switch (action.type) {
		case MessageActions.DISPLAY_MESSAGE:
			const message = Object.assign({}, action.payload, {id: state.messages.length + 1})
			return {
				messages: [message]
			}
		case MessageActions.REMOVE_MESSAGE:
			return {
				messages: state.messages.filter(msg => msg.id !== action.payload)
			}
		case MessageActions.CLEAR_MESSAGES:
			return {
				messages: []
			}
		default: {
			return state;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/reducers/message.reducer.ts